import { useState } from 'react'
import { Link } from 'react-router-dom'
import ContactList from '../contacts/ContactList'
import ContactDetail from '../contacts/ContactDetail'
import RegionFilter from '../filters/RegionFilter'
import SpeciesFilter from '../filters/SpeciesFilter'
import ConfidenceFilter from '../filters/ConfidenceFilter'
import ReportForm from '../report/ReportForm'
import { useContactStore } from '../../store/contactStore'
import { useAuth } from '../../hooks/useAuth'

// Desktop-only fixed side panel — see MobileSheet for the equivalent below the md breakpoint
// (rendered as a separate component tree, not a CSS-collapsed version of this one; see
// App.tsx's MapPage and CAP-alert-platform's Sidebar/MobileSheet split for why: a `position:
// fixed` sheet had unreliable nested-scroll behavior on iOS Safari that `position: absolute`
// within a `relative` wrapper doesn't).
export default function Sidebar() {
  const selectedId = useContactStore((s) => s.selectedContactId)
  const { username, isAuthenticated, isAdmin, credibilityTier, logout } = useAuth()
  const [showReportForm, setShowReportForm] = useState(false)

  return (
    <aside className="flex flex-col h-full bg-gray-50 border-r border-gray-200 w-80 xl:w-96 shrink-0">
      <div className="flex items-center justify-between px-3 py-2.5 border-b border-gray-200 shrink-0 flex-wrap gap-y-1">
        <span className="text-sm font-semibold text-gray-900">Biosecurity Reporter</span>
        <div className="flex items-center flex-wrap justify-end gap-2">
          <Link to="/about" className="text-xs text-gray-500 hover:text-gray-700">About</Link>
          {isAuthenticated ? (
            <>
              {isAdmin && (
                <Link to="/admin" className="text-xs text-gray-500 hover:text-gray-700">Admin</Link>
              )}
              {credibilityTier !== 'verified_professional' && (
                <Link to="/professional-tier" className="text-xs text-gray-500 hover:text-gray-700">Pro tier</Link>
              )}
              <Link to="/my-reports" className="text-xs text-gray-500 hover:text-gray-700">My reports</Link>
              <span className="text-xs text-gray-500 truncate max-w-[80px]" title={username ?? ''}>
                {username}
              </span>
              <button type="button" onClick={logout} className="text-xs text-gray-500 hover:text-gray-700">
                Sign out
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="text-xs text-gray-500 hover:text-gray-700">Sign in</Link>
              <Link to="/register" className="text-xs text-blue-600 hover:text-blue-700 font-medium">Register</Link>
            </>
          )}
        </div>
      </div>

      <div className="px-3 py-2 border-b border-gray-200 shrink-0">
        <button
          type="button"
          onClick={() => (isAuthenticated ? setShowReportForm(true) : undefined)}
          className="w-full rounded-lg bg-blue-600 hover:bg-blue-500 text-white text-sm font-semibold py-2 transition"
        >
          {isAuthenticated ? 'Report a potential contact' : (
            <Link to="/login" className="block text-white">Sign in to report a contact</Link>
          )}
        </button>
      </div>

      <div className="border-b border-gray-200 shrink-0">
        <RegionFilter />
        <SpeciesFilter />
        <ConfidenceFilter />
      </div>

      <div className="flex-1 overflow-hidden">
        {selectedId ? <ContactDetail /> : <ContactList />}
      </div>

      {showReportForm && (
        <ReportForm
          onClose={() => setShowReportForm(false)}
          onSubmitted={() => setShowReportForm(false)}
        />
      )}
    </aside>
  )
}
